module.exports = __webpack_public_path__ + "static/img/annex.66b42260.svg";